export const APH = 'API/PROCESS_HANDLER';

export const NON_ENTITY_CALL = 'NON_ENTITY_CALL';

// Entity key types enum for better type safety
export const ENTITY_KEY_TYPES = {
  SINGLE: 'single',
  PLURAL: 'plural',
  STATE: 'state',
  COLLECTION: 'collection',
} as const;

export type EntityKeyType = typeof ENTITY_KEY_TYPES[keyof typeof ENTITY_KEY_TYPES];

// Request methods with proper typing
export const REQUEST_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  ARCHIVE: 'PATCH',
  UNARCHIVE: 'PATCH',
} as const;

// Request method type (includes convenience constants like ARCHIVE/UNARCHIVE)
// Note: HTTPMethod type is defined in types/actions.ts to maintain proper layering
export type RequestMethod = typeof REQUEST_METHODS[keyof typeof REQUEST_METHODS];
